import { createApp } from "vue";
import App from "./App.vue";

import Oruga from "@oruga-ui/oruga-next";
import "@oruga-ui/oruga-next/dist/oruga.min.css";

import "@mdi/font/css/materialdesignicons.css";

import "@/assets/styles/_reset.css";
import "@/assets/styles/_base.css";
import "@/assets/styles/_glyphs.css";
import "@/assets/styles/_animations.css";
import "@/assets/styles/_flavor-text.css";

import router from "./router";
import tip from "./directives/tip";
import decrypt from "./directives/decrypt";
import marquee from "./directives/marquee";

createApp(App)
	.use(router)
	.use(Oruga)
	.directive("tip", tip)
	.directive("decrypt", decrypt)
	.directive("marquee", marquee)
	.mount("#app");
// TODO: Introduce eslint with vue3 + typescript support
